import { AxiosInstance } from 'axios'

import {
  CreateEmployeesDriverLicensesRequest,
  UploadEmployeeDriverLicenseFileRequest,
} from '@modules/employees/types/EmployeesDriversLicenses/requests'
import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'

export class EmployeesDriverLicensesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesDriverLicensesRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/driver-licenses`, body)

    return response.data
  }

  async uploadFile({ employeeId, file }: UploadEmployeeDriverLicenseFileRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await this.instance.post(`/companies/employees/${employeeId}/driver-licenses/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesDriverLicensesService = (instance: AxiosInstance) => new EmployeesDriverLicensesService(instance)
